import type { ReactNode } from 'react';

interface ClusterSectionProps {
  label: string;
  children: ReactNode;
}

export function ClusterSection({ label, children }: ClusterSectionProps) {
  return (
    <section className="mb-12">
      <div className="text-[10px] font-semibold tracking-[0.14em] uppercase text-placeholder mb-3.5 pb-2 border-b border-border">
        <span className="text-primary/60 mr-1" aria-hidden="true">§</span>
        {label}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-3.5">
        {children}
      </div>
    </section>
  );
}
